// GLOBALS AND CONSTANTS
const CONFIG = {};
const DATA = {};

// starting conditions
CONFIG.startzoom = 9;
CONFIG.minzoom   = CONFIG.startzoom - 1;
CONFIG.maxzoom   = 15;
CONFIG.startlat  = 36.356317;
CONFIG.startlng  = -121.28843;

// Monterey County BBOX
CONFIG.bbox_w = -121.97838;
CONFIG.bbow_s = 35.78897;
CONFIG.bbox_e = -120.21397;
CONFIG.bbox_n = 36.91956;

// max bounds
CONFIG.maxbounds = [[37.6, -124],[34.6, -118.3]];

// where to find map tiles, and an object to hold them
CONFIG.maptiles_url = 'https://tamc-aecom-maptiles.s3-us-west-1.amazonaws.com/';
CONFIG.maplayers = {};
CONFIG.current_z = 200;

// colors, styles and things
CONFIG.rcis_boundary_style = { fill: false, color: '#000000', opacity: 0.8, weight: 3 };

///////////////////////////////////////////////////////////////////////////////////////////////////////////
// INITIALIZATION: these functions are called when the page is ready,
///////////////////////////////////////////////////////////////////////////////////////////////////////////
$(document).ready(function() {

	Promise.all([
			// get static data files
			initData(`${BASEURL}/static/data/rcis_boundary.json`),
	    ]).then(function(data) {
	    	initDataFormat(data);
			initTabs();
			initMap();
			initMapControls();
		});
});




///////////////////////////////////////////////////////////////////////////////////////////////////////////
// Functions called on doc ready
///////////////////////////////////////////////////////////////////////////////////////////////////////////

// Generic data init, returns a promise
function initData(url) {
	// get some data from a url
	// wrap this in a promise, so we know we have it before continuing on to remaining initialize steps
	return new Promise(function(resolve, reject) {
		$.get(url, function(data) {
			resolve(data);
		});
	});
}

// data formatting functions
function initDataFormat(data) {
	// just keep a reference to this one, nothing more 
	DATA.rcis_boundary_raw = data[0];
}

// init the internal page nav tabs
function initTabs() {
	$('div#page-nav-wrapper ul li a').on('click', function() {
		// remove the active class from any siblings
		$('div#page-nav-wrapper ul li a').removeClass('active');

		// add it to this one
		$(this).addClass('active');
	})
}


// map layers control
function initMapControls() {
	// init the map options button and layer panel
	$('div#map-options-toggle').on('click', function() {
		let button = $(this);
		let map_options_panel = $('div#map-options');

		if (map_options_panel.is(':visible')) {
			button.find('svg.plus').show();
			button.find('svg.close').hide();
			map_options_panel.hide();
		} else {
			button.find('svg.plus').hide();
			button.find('svg.close').show();
			map_options_panel.show();
		}
	});


	// create the legend for the species rangemap, from one of nine types
	let legend_template = $('div#legend-templates div.legend');
	let legend;
	legend_template.each(function() {
		let targets = this.dataset.targets.split(',');
		if (targets.indexOf(SPECIES_KEY) > -1) {
			legend = $(this).clone();
			$('div#rangemap').append(legend);
			return;
		}
	});

	// init the layer controls themselves, and add the map layers
	let layerchecks = $('div#map-options div.form-check input.form-check-input');
	let rangemap = $('div#map-options div.form-check input.form-check-input[name="rangemap"]').val(SPECIES_KEY);

	// init the Leaflet layers
	layerchecks.each(function() {
		let layername = $(this).val();

		// create and save a reference to an L.tilelayer for the layer
		let tilelayer = L.tileLayer(CONFIG.maptiles_url + layername + '/{z}/{x}/{y}.png', {
		  	opacity: 0.5,
		  	zIndex: CONFIG.current_z + 1,
		 });
		CONFIG.maplayers[layername] = tilelayer;
		CONFIG.current_z += 1;
	});

	// then register the change function on the checkboxes
	layerchecks.on('change', function() {
		let input = $(this);
		let map = input.val();

		if (input.is(':checked')) {
			CONFIG.map.addLayer(CONFIG.maplayers[map]);
			let legend = input.siblings('div.legend').show();
		} else {
			CONFIG.map.removeLayer(CONFIG.maplayers[map]);
			let legend = input.siblings('div.legend').hide();
		}
	})

	// add the rangemap to the map by clicking the checkbox 
	rangemap.click();

	// init the opacity range sliders
	$('div.legend input[type="range"]').on('change', function() {
		let slider = $(this);
		let layername = slider.parent().siblings('input').val();
		let opacity = slider.val() / 100;
		CONFIG.maplayers[layername].setOpacity(opacity);
	});

}

// the map init
function initMap() {

	CONFIG.map = L.map('map', {
		minZoom: CONFIG.minzoom,
		maxZoom: CONFIG.maxzoom,
		attributionControl: false,
		scrollWheelZoom: false,
		zoomControl: false,
		maxBounds: CONFIG.maxbounds,
	}).fitBounds([[36.91956, -120.21397],[35.78897,-121.97838]])

	// add the basemap without labels
	L.tileLayer('https://{s}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}' + (L.Browser.retina ? '@2x.png' : '.png'), {
   		attribution:'&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>',
		maxZoom: CONFIG.maxzoom,
	  	minZoom: CONFIG.minzoom,
	  	subdomains: 'abcd',
	  	zIndex: 200,
	 }).addTo(CONFIG.map);

	// add the custom zoom home control
	new L.Control.ZoomBar({
		position: 'topleft',
		homeLatLng: [CONFIG.startlat, CONFIG.startlng],
		homeZoom: CONFIG.startzoom,
	}).addTo(CONFIG.map);

	// add the RCIS boundary to the map
	L.geoJSON(DATA.rcis_boundary_raw, { style: CONFIG.rcis_boundary_style, zIndex: 550 } ).addTo(CONFIG.map);

	// add the basemap _with_ labels to a custom pane, so that its over top of everything
	let labelpane = CONFIG.map.createPane();
	labelpane.style.zIndex = 650;
	labelpane.style.pointerEvents = 'none';
	L.tileLayer('https://{s}.basemaps.cartocdn.com/light_only_labels/{z}/{x}/{y}' + (L.Browser.retina ? '@2x.png' : '.png'), {
   		attribution:'&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>',
		maxZoom: CONFIG.maxzoom,
	  	minZoom: CONFIG.minzoom,
	  	subdomains: 'abcd',
	  	zIndex: 700,
	  	pane: labelpane,
	 }).addTo(CONFIG.map);


	// Extra: ensure that clicks/scroll on the map layer picker doesn't propagate to the map
	$('div#map-options').on("mousedown wheel dblclick", L.DomEvent.stopPropagation);
	$('div#map-options-toggle').on("mousedown wheel dblclick", L.DomEvent.stopPropagation);
}